import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const BUSINESS_INFO_EDIT_MODAL_OPEN = 'BUSINESS_INFO_EDIT_MODAL_OPEN'
export const BUSINESS_INFO_EDIT_MODAL_CLOSE = 'BUSINESS_INFO_EDIT_MODAL_CLOSE'
export const BUSINESS_INFO_EDIT_MODAL_CANCEL = 'BUSINESS_INFO_EDIT_MODAL_CANCEL'
export const BUSINESS_INFO_EDIT_MODAL_SAVE_CHANGES = 'BUSINESS_INFO_EDIT_MODAL_SAVE_CHANGES'
export const BUSINESS_INFO_EDIT_MODAL_VALIDATE = 'BUSINESS_INFO_EDIT_MODAL_VALIDATE'
export const BUSINESS_INFO_EDIT_MODAL_RESET = 'BUSINESS_INFO_EDIT_MODAL_RESET'

function open(content) {
  return {
    type: BUSINESS_INFO_EDIT_MODAL_OPEN,
    content,
  }
}

function close() {
  return {
    type: BUSINESS_INFO_EDIT_MODAL_CLOSE,
  }
}

function cancel() {
  return {
    type: BUSINESS_INFO_EDIT_MODAL_CANCEL,
  }
}

function saveChanges(newData) {
  return {
    type: BUSINESS_INFO_EDIT_MODAL_SAVE_CHANGES,
    newData,
  }
}

function validate(isValidated) {
  return {
    type: BUSINESS_INFO_EDIT_MODAL_VALIDATE,
    isValidated,
  }
}

function reset() {
  return {
    type: BUSINESS_INFO_EDIT_MODAL_RESET,
  }
}

export function openBusinessInfoModalDialog(content) {
  return (dispatch) => {
    dispatch(open(content))
  }
}

export function closeBusinessInfoModalDialog() {
  return (dispatch) => {
    dispatch(close())
  }
}

export function cancelBusinessInfoModalDialog() {
  return (dispatch) => {
    dispatch(cancel())
  }
}

export function saveChangesBusinessInfoModalDialog(data) {
  return (dispatch) => {
    dispatch(saveChanges(data))
  }
}

export function validateBusinessInfoModalDialog(isValid) {
  return (dispatch) => {
    dispatch(validate(isValid))
  }
}

export function resetBusinessInfoModalDialog() {
  return (dispatch) => {
    dispatch(reset())
  }
}

// API call to update business info
export const BUSINESS_INFO_EDIT_UPDATE_REQUEST = 'BUSINESS_INFO_EDIT_UPDATE_REQUEST'
export const BUSINESS_INFO_EDIT_UPDATE_SUCCESS = 'BUSINESS_INFO_EDIT_UPDATE_SUCCESS'
export const BUSINESS_INFO_EDIT_UPDATE_FAILURE = 'BUSINESS_INFO_EDIT_UPDATE_FAILURE'

export function updateBusinessInformation(id, body) {
  return {
    [CALL_API]: {
      endpoint: '/api/business/businesses/' + id + '/',
      types: [BUSINESS_INFO_EDIT_UPDATE_REQUEST, BUSINESS_INFO_EDIT_UPDATE_SUCCESS, BUSINESS_INFO_EDIT_UPDATE_FAILURE],
      method: 'PATCH',
      body,
      tokenType: API_JWT_TOKEN_NAME,
    },
  }
}
